import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  CardGroup,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import {
  getAllDailyExpenses,
  resetExpenseList,
} from "../features/dailyexpense/dailyExpenseSlice";
import {
  getAllSalaries,
  resetSalaryList,
} from "../features/salary/salarySlice";
import moment from "moment";
import { logout } from "../features/user/userSlice";
import { LinkContainer } from "react-router-bootstrap";
import { GrPowerReset } from "react-icons/gr";
import { TiPrinter } from "react-icons/ti";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: "38",
  },
  section: {
    // margin: 20,
    // padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#3c8dbc",
    textAlign: "center",
    marginBottom: 10,
    fontFamily: "Helvetica-Bold",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // bottom: -100,
    // width: "20%",
    // position: "absolute",
  },
  signatureLeft: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "center",
    fontFamily: "Helvetica",
    justifyContent: "flex-start",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  signatureRight: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "right",
    fontFamily: "Helvetica",
    justifyContent: "flex-end",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  line: {
    border: "1px dashed black",
    borderRadius: "1px",
    width: "150%",
  },
  header: {
    // family: "Open Sans",
    fontSize: 12,
    // fontWeight: "bold",
    // fontWeight: "1000",
    textAlign: "center",
    margin: 20,
    fontFamily: "Helvetica-Bold",
  },
  address: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 10,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  table: {
    // display: "table",
    // width: "100%",
    // borderStyle: "dotted",
    // borderWidth: 1,
    // borderCollapse: "collapse",
    // borderBottom: 1,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    borderStyle: "dotted",
  },
  tableRow2: {
    flexDirection: "row",
    borderStyle: "dotted",
  },
  tableCell: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    // padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
    fontFamily: "Helvetica-Bold",
  },

  tableData: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
    flex: 1,
  },

  agentName: {
    // displayL: "table",
    // fontFamily: 'Open Sans',
    // width: "auto",
    fontSize: 10,
    fontWeight: 600,
    textAlign: "left",
    borderStyle: "dotted",
    borderWidth: 1,
    borderCollapse: "collapse",
    paddingLeft: 15,
    paddingBottom: 5,
    paddingTop: 5,
    marginBottom: 20,
  },
});

const TotalMonthlyExpenses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [printPreview, setPrintPreview] = useState(false);

  // State variables
  const [combineData, setCombineData] = useState([]);

  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");

  const [searchByExpenseType, setSearchByExpenseType] = useState("");

  // Selectors
  const { userInfo } = useSelector((state) => state.user);
    const [totalExpense, setTotalExpense] = useState(0);

  const {
    dailyExpenses,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,
  } = useSelector((state) => state.dailyExpense);

  const {
    salaries,
    isListLoading: isSalaryListLoading,
    isListError: isSalaryListError,
    isListSuccess: isSalaryListSuccess,
    listErrorMessage: salaryListErrorMessage,
  } = useSelector((state) => state.salary);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("totalMonthlyExpenses") === false) {
      toast.error("Don't Try To Be Too Clever!!!", { position: "top-center" });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

    // State to store filtered passports
    const [filteredExpense, setFilteredExpense] = useState([]);

  // If list error occurs shows toast with a delay of 3 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isListError || isSalaryListError) {
        toast.error(listErrorMessage || salaryListErrorMessage, {
          position: "top-center",
        });
      }
    }, 3000); // Delay error toast for 3 seconds

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [
    isListError,
    isSalaryListError,
    listErrorMessage,
    salaryListErrorMessage,
  ]);

  useEffect(() => {
    // if (isListError || isSalaryListError) {
    //   toast.error(listErrorMessage || salaryListErrorMessage, {
    //     position: "top-center",
    //   });
    // }
    if (isListSuccess && isSalaryListSuccess) {
      const mergedData = [
        ...dailyExpenses.map((expense) => ({
          type: "Daily Expense",
          date: moment(expense.createdAt).format("YYYY-MM-DD"),
          // date: expense.createdAt,
          amount: expense.amount,
          description: expense.description,
        })),
        ...salaries.map((salary) => ({
          type: "Salary",
          date: moment(salary.createdAt).format("YYYY-MM-DD"),
          // date: salary.createdAt,
          amount: salary.amount,
          description: salary.employeeName,
        })),
      ];

      // setCombineData(mergedData);

      // Apply Search Filters
      const filteredData = mergedData
        .filter((item) => {
          //Filter By Expense Type
          if (searchByExpenseType === "" || item.type === searchByExpenseType) {
            return true;
          } else {
            return false;
          }
        })
        .filter((item) => {
          //Filter By Date
          if (selectDateFrom && selectDateTo) {
            return item.date >= selectDateFrom && item.date <= selectDateTo;
          }
          return true;
          // if (selectDateFrom === "" || selectDateTo === "") {
          //   return true;
          // } else {
          //   const itemDate = new Date(item.date);
          //   // const fromDate = new Date(selectDateFrom);
          //   // const toDate = new Date(selectDateTo);
          //   return (
          //     itemDate >= new Date(selectDateFrom) &&
          //     itemDate <= new Date(selectDateTo)
          //     // itemDate >= fromDate && itemDate <= toDate
          //   );
          // }
        });
      setFilteredExpense(filteredData);
    }
  }, [
    // dispatch,
    salaries,
    dailyExpenses,
    isListError,
    isSalaryListError,
    isListSuccess,
    isSalaryListSuccess,
    listErrorMessage,
    salaryListErrorMessage,
    selectDateFrom,
    selectDateTo,
    searchByExpenseType,
  ]);

  useEffect(() => {
    dispatch(getAllSalaries());
    dispatch(getAllDailyExpenses());

    return () => {
      dispatch(resetExpenseList());
      dispatch(resetSalaryList());
    };
  }, [dispatch]);


    useEffect(() => {
      const totalExpenseAmount = combineData.reduce(
        (acc, item) => acc + item.amount,
        0
      );
      setTotalExpense(totalExpenseAmount);
    }, [combineData, totalExpense]);


  
    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 30;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const records = filteredExpense.slice(firstIndex, lastIndex);
    const npage = Math.ceil(filteredExpense.length / recordsPerPage); // Total pages
    const numbers = [...Array(npage + 1).keys()].slice(1);

    // console.log("Total : " ,records.length);


  return (
    <>
      {printPreview ? (
        <>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page} orientation="landscape">
                <View style={styles.section}>
                  <Text style={styles.title}>Northeast Overseas LTD.</Text>
                  <Text style={styles.address}>
                    Gulfesha Plaza, 12/0, 69 Outer Circular Road, Boro Mogbazar,
                    Dhaka-1217
                  </Text>
                  <Text style={styles.address}>
                    Phone: +880241031411-2 || Email: info@northeastoverseas.com
                  </Text>

                  <Text style={styles.header}>MONTHLY EXPENSE LIST</Text>

                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCell}>
                          <Text>SL</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Expense Type</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Amount</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Description</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Date</Text>
                        </View>
                      </View>
                      {combineData.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                          <View style={styles.tableData}>
                            <Text>{index + 1}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{item.type}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{item.amount}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{item.description}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{item.date}</Text>
                          </View>
                        </View>
                      ))}

                      <View style={styles.tableRow2}>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                        <View style={[styles.tableCell, { paddingTop: 5 }]}>
                          <Text>Total Expense : {totalExpense}</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text></Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  {/* Signature Section */}
                  <View style={styles.footer}>
                    <View style={styles.row}>
                      <View style={styles.signatureLeft}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Agent Signature
                        </Text>
                      </View>

                      <View style={styles.signatureRight}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Authorized Signature
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
          <Button variant="danger" onClick={() => setPrintPreview(false)}>
            Cancel
          </Button>
        </>
      ) : (
        <Container fluid className="my-4">
          <Row className="mb-4">
            <Card
              className="rounded-4 border"
              style={{ backgroundColor: "#e6edf1" }}
            >
              <h2 className="my-3 text-dark text-center fw-bold">
                Total <span style={{ color: "#5c91dc" }}>Expenses</span>
              </h2>
            </Card>
          </Row>

          <Row className="my-4">
            <CardGroup className="p-0">
              {/* Search By Expense Type */}
              <Card>
                <Card.Header
                  className="text-center fw-bold text-black"
                  style={{ backgroundColor: "#74a2e3" }}
                  as="h6"
                >
                  Search By Expense Type
                </Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Control
                      as="select"
                      type="select"
                      placeholder="Select Expense Type"
                      name="expenseType"
                      onChange={(e) => setSearchByExpenseType(e.target.value)}
                      className="shadow-rounded"
                    >
                      <option value="">Select Expense Type</option>
                      <option value="Daily Expense">Daily Expense</option>
                      <option value="Salary">Salary</option>
                    </Form.Control>
                  </Form>
                </Card.Body>
              </Card>
              {/* Search By Date Range */}
              <Card>
                <Card.Header
                  className="text-center fw-bold text-black"
                  style={{ backgroundColor: "#74a2e3" }}
                  as="h6"
                >
                  Search By Date Range
                </Card.Header>

                <Card.Body>
                  <Form>
                    <Row>
                      <Col>
                        <Form.Group controlId="dateFrom">
                          <Form.Label className="fw-bold text-black">
                            From
                          </Form.Label>
                          <Form.Control
                            type="date"
                            // value={selectDateFrom}
                            onChange={(e) => setSelectDateFrom(e.target.value)}
                            className="shadow-rounded"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="dateTo">
                          <Form.Label className="fw-bold text-black">
                            To
                          </Form.Label>
                          <Form.Control
                            type="date"
                            // value={selectDateTo}
                            onChange={(e) => setSelectDateTo(e.target.value)}
                            className="shadow-rounded"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>

                <Card.Footer>
                  <Col className="d-flex justify-content-end">
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        setSelectDateFrom("");
                        document.getElementById("dateFrom").value = "";
                        setSelectDateTo("");
                        document.getElementById("dateTo").value = "";
                      }}
                    >
                      <GrPowerReset className="mb-1" /> Reset
                    </Button>
                  </Col>
                </Card.Footer>
              </Card>
            </CardGroup>
          </Row>

          <Row>
            {/* Print Button */}
            <Col className="mb-3 mt-2 d-flex justify-content-end">
              <Button
                variant="outline-success"
                className="fw-bold"
                onClick={() => setPrintPreview(true)}
              >
                <TiPrinter className="mb-1" />
                &nbsp; Print List
              </Button>
            </Col>
            <Card style={{ backgroundColor: "#74a2e3" }}>
              <Card.Header
                className="text-center text-black p-3 fw-bold"
                style={{ backgroundColor: "#74a2e3" }}
                as="h5"
              >
                All Expenses
              </Card.Header>

              <Table responsive border hover>
                <thead className="text-center">
                  <tr>
                    <th>Expense Type</th>
                    <th>Amount</th>
                    <th>Description</th>
                    <th>Date</th>
                  </tr>
                </thead>

                {isListLoading || isSalaryListLoading ? (
                  <Loader />
                ) : (
                  <>
                    {records && records.length > 0 ? (
                      <tbody className="text-center">
                        {records.map((item, index) => (
                          <tr key={index} style={{ cursor: "pointer" }}>
                            <td style={{ padding: "0px" }}>{item.type}</td>
                            <td style={{ padding: "0px" }}>{item.amount}</td>
                            <td style={{ padding: "0px" }}>
                              {item.description}
                            </td>
                            <td style={{ padding: "0px" }}>
                              {moment(item.date).format("DD-MMMM-YYYY")}
                              {/* {item.date} */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tr>
                        <th colSpan="4" className="text-center bg-light">
                          No Data Found
                        </th>
                      </tr>
                    )}
                  </>
                )}
              </Table>

              <nav className="d-flex justify-content-center">
                <ul className="pagination">
                  <li className="page-item">
                    <a href="#" className="page-link" onClick={prePage}>
                      Prev
                    </a>
                  </li>

                  {/* Show the first two pages */}
                  {numbers.slice(0, 2).map((n, index) => (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={index}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </a>
                    </li>
                  ))}

                  {/* Show ellipsis if currentPage is beyond page 3 */}
                  {currentPage > 3 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}

                  {/* Show the middle range of pages */}
                  {numbers
                    .slice(
                      Math.max(currentPage - 2, 2),
                      Math.min(currentPage + 1, npage - 1)
                    )
                    .filter((n) => ![1, npage].includes(n)) // Exclude the first and last page from middle range
                    .map((n, index) => (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={index}
                      >
                        <a
                          href="#"
                          className="page-link"
                          onClick={() => changeCPage(n)}
                        >
                          {n}
                        </a>
                      </li>
                    ))}

                  {/* Show ellipsis if not near the last pages */}
                  {currentPage < npage - 2 && (
                    <li className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  )}

                  {/* Show the last two pages, ensuring they do not repeat */}
                  {numbers.slice(-2).map((n, index) =>
                    n !== 1 &&
                    n !== currentPage &&
                    n !== currentPage - 1 &&
                    n !== currentPage + 1 ? (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={index}
                      >
                        <a
                          href="#"
                          className="page-link"
                          onClick={() => changeCPage(n)}
                        >
                          {n}
                        </a>
                      </li>
                    ) : null
                  )}

                  <li className="page-item">
                    <a href="#" className="page-link" onClick={nextPage}>
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </Card>
          </Row>
        </Container>
      )}
    </>
  );
   function prePage() {
     if (currentPage > 1) {
       // Check if there's a previous page
       setCurrentPage(currentPage - 1);
     }
   }

   function changeCPage(id) {
     setCurrentPage(id);
   }

   function nextPage() {
     if (currentPage < npage) {
       // Check if there's a next page
       setCurrentPage(currentPage + 1);
     }
   }
};

export default TotalMonthlyExpenses;
